import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanLoad, CanMatchFn, GuardResult, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const loginAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot, 
  state: RouterStateSnapshot): GuardResult => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  return authService.isAuthenticated() ? router.createUrlTree(['/authenticate']) : true;
};